angular.module('unica_check.check_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// INVITATION LIST
		.state('app.check', {
			url: '/check',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/check/templates/check.html',
					controller: 'CheckBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

			// INVITATION LIST LIST
			.state('app.check.check_invitation', {
				url: '/check-invitation/:event_id',
				views: {
					'checkContent': {
						templateUrl: './modules/check/templates/check-invitation.html',
						controller: 'CheckInvitationController'
					}
				},
				ncyBreadcrumb: {
					label: 'Check Inviti',
					parent: function($scope) {
						return 'app.event.detail({year:' + $scope.year + ',id:' + $scope.event_id + '})';
					}
				}
			});


});

